export const REPORT_TYPES = {
    NORMALIZED_FILE: 'normalized_file_report',
    NORMALIZED_MULTIPLE_SOURCE: 'normalized_multiple_source_report',
    NORMALIZED_RECORD: 'normalized_multiple_source_report',
};